import { Colors } from 'ComponentLibrary/src/styles'
import { Icon as ReactFeatherIcon, IconProps as ReactFeatherIconProps } from 'react-feather'

type IconProps = ReactFeatherIconProps & {
    icon: ReactFeatherIcon
    variant?: 'muted' | 'primary'
}

/**
 * Icon component that renders an icon from react-feather with a default color
 */
export default function Icon({ icon, color: customColor, variant = 'primary', ...rest }: IconProps) {
    const color = customColor || (variant === 'muted' ? Colors.primary1.blue20 : Colors.primary1.blue100)
    const Component = icon
    return <Component color={color} {...rest} />
}
